import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize16 {
  size: '16';
}
type OverrideIconSize = OverrideIconSize16;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '16') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0461 2.35036C13.049 2.07423 12.8275 1.84804 12.5513 1.84515C12.2752 1.84226 12.049 2.06377 12.0461 2.33989L12.0334 3.55797C10.9683 2.59039 9.55311 2 8 2C4.68629 2 2 4.68629 2 8C2 8.27614 2.22386 8.5 2.5 8.5C2.77614 8.5 3 8.27614 3 8C3 5.23857 5.23858 3 8 3C9.31247 3 10.5069 3.50539 11.3993 4.33323L10.0253 4.31886C9.7492 4.31597 9.52301 4.53747 9.52013 4.8136C9.51724 5.08973 9.73874 5.31591 10.0149 5.3188L12.5147 5.34496C12.7909 5.34785 13.017 5.12635 13.0199 4.85022L13.0461 2.35036ZM7.99927 13C10.7607 13 12.9993 10.7614 12.9993 8C12.9993 7.72385 13.2231 7.5 13.4993 7.5C13.7754 7.5 13.9993 7.72385 13.9993 8C13.9993 11.3137 11.313 14 7.99927 14C6.42822 14 4.99828 13.3959 3.92911 12.4083L3.92463 13.674C3.92366 13.9501 3.69901 14.1732 3.42287 14.1722C3.14673 14.1712 2.92366 13.9466 2.92464 13.6704L2.93347 11.1704C2.93445 10.8943 3.1591 10.6712 3.43524 10.6722L5.93522 10.6811C6.21136 10.682 6.43443 10.9067 6.43345 11.1828C6.43248 11.459 6.20783 11.682 5.93169 11.681L4.61032 11.6764C5.50164 12.4985 6.69189 13 7.99927 13Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 16 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'refresh');
export default IconComponent;
